import { fromJS } from 'immutable';

const INITIAL_STATE = fromJS({
  products: {},
});

export function setProduct(state, procuct) {
  const arr = Array.isArray(procuct) ? procuct : [procuct];
  return state
    .mergeIn(['products'], fromJS(arr.reduce((obj, pro) => ({ ...obj, [pro.CatalogID3DCart]: pro }), {})));
}

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case 'PRODUCTS_SET':
      return setProduct(state, action.products);

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./app/reducers/products.js